exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".edit-avatar-dialog{margin-top:25vh !important}.edit-avatar-dialog .el-dialog__header{background:#1a202f !important}", "", {"version":3,"sources":["/var/jenkins_home/workspace/s01-aiart-release-cn/s01_haiyiai_release-cn_aiart-web-openapi/src/components/SetUserPopup.vue"],"names":[],"mappings":"AACA,oBACE,0BAAA,CACA,uCACE,6BAAA,CAAA","file":"SetUserPopup.vue?vue&type=style&index=1&id=0f878be2&lang=scss&","sourcesContent":["\n.edit-avatar-dialog {\n  margin-top: 25vh !important;\n  .el-dialog__header {\n    background: #1a202f!important;\n  }\n}\n"],"sourceRoot":""}]);

// exports
